import { useAuth } from "../../../usercontext";
import StudentActivitiesList from "./activities";
import STopMenu from "../../student/topmenu/topmenu";
import S12TopMenu from "../topmenu/topmenu";
import S911TopMenu from "../topmenu/topmenu";

export default function StudentActivitiesAndAwards() {
  const { profile } = useAuth();
  const slug = profile.id;
  const isStudent12 = profile?.role === "Student12";
  const isStudent = profile?.role === "Student";
  const isStudent911 = profile?.role === "Student911";
  return (
    <>
      {isStudent && <STopMenu slug={slug} activeMenu="StudentCollegeList" />}
      {isStudent12 && <S12TopMenu slug={slug} activeMenu="StudentCollegeList" />}
      {isStudent911 && <S911TopMenu slug={slug} activeMenu="StudentCollegeList" />}
      <StudentActivitiesList  />
    </>
  );
}